import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './NoticeCard.module.scss'

const NoticeCard = ({ icon, title, body, children }) => (
  <main className={classes.page}>
    <section className={classNames('d-flex flex-column align-items-center text-center p-5', classes.card)}>
      <span className={classNames('d-flex align-items-center justify-content-center mb-3', classes.icon)}>
        <i className={icon} aria-hidden='true' />
      </span>
      <h2 className={classNames('mb-1', classes.headline)}>{title}</h2>
      <p className={classNames('mb-0', classes.text)}>{body}</p>
      {children}
    </section>
  </main>
)

NoticeCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default NoticeCard
